<template>
    <tr class="c-tr">
        <td @click="handleRedirect">{{ data.title }}</td>
        <td v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_VIEW)" @click="handleRedirect" class="text-right pr-5">${{ new Intl.NumberFormat().format(data.curr_amount) }}</td>
        <td @click="handleRedirect">{{ data.start_date }}</td>
        <td @click="handleRedirect">{{ data.end_date }}</td>
        <td @click="handleRedirect" :style="{ color: `${data.type_color}` }">{{ data.type_name }}</td>
        <td @click="handleRedirect" :style="{ color: `${data.status_color}` }">
            {{ data.status_name }}
        </td>
        <td>
            <a href="javascript:;" v-if="data.status === 2 && DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_VIEW_MANUAL_DONATION)" @click="manualDonate()">
                <img src="@/assets/images/Donate.svg" alt="Manual Donate"/>
            </a>
        </td>
    </tr>
</template>

<script>
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'TableItem',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    props: {
        data: Object,
    },
    methods: {
        handleRedirect() {
            if (DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_VIEW)) {
                this.$router.push({
                    name: 'CampaignsView',
                    params: {
                        id: this.data.campaign_id,
                    },
                });
            }
        },
        manualDonate() {
            this.$emit('manualDonate', this.data);
        }
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
</style>
